import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ItemBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  borderBottom: `1px solid ${theme.colors.borderBottom}`,
  padding: theme.spacing(1, 2),

  '&:last-child': {
    borderBottom: 'none',
  },
}));
